




import { Vue, Component } from 'vue-property-decorator'
import { Image as VanImage } from 'vant'
import { parseInt, isUndefined } from 'lodash'
import { compressImage } from '@utils/index'

@Component({
  components: {
    [VanImage.name]: VanImage,
  },
})
export default class ImgHzw extends Vue {
  /**
   * tailor:是否裁剪
   * optimize:是否优化 不优化也没有裁剪
   * zoom:默认将压缩图片放大2倍，防止太过模糊
   */
  get attrs() {
    const attrs: any = this.$attrs
    if (attrs.src) {
      const width = attrs.width ? parseInt(attrs.width) : undefined
      const height = attrs.height ? parseInt(attrs.height) : undefined
      const isTailor: boolean = attrs.tailor
      const isPptimize: boolean = isUndefined(attrs.optimize)
        ? true
        : attrs.optimize
      const zoom = attrs.zoom ? parseInt(attrs.zoom) : 2
      attrs.src = isPptimize
        ? compressImage(attrs.src, width && width * zoom, height && height * zoom, isTailor)
        : attrs.src
    }

    attrs['icon-prefix'] = isUndefined(attrs['icon-prefix'])
      ? 'hzw-yr'
      : attrs['icon-prefix']

    if (attrs.width) {
      attrs.width = `${parseInt(attrs.width) / 75}rem`
    }
    if (attrs.height) {
      attrs.height = `${parseInt(attrs.height) / 75}rem`
    }
    if (attrs.fit) {
      attrs.fit = attrs.fit
    } else {
      attrs.fit = 'cover'
    }
    return attrs
  }
}
